export default function FindingReportDirective() {
  return {
    template: require('./finding-report.html'),
    scope: {
      findingId: '=',
      canEdit: '=',
      canDelete: '=',
      findingReport: '=',
    },
    controller: 'FindingReportController',
    controllerAs: 'findingReportVM',
    bindToController: true,
    replace: true
  };
}
